import { HD, FULL_HD, safetyMargins } from '@bedrock-rdk/constants';

export { CONTENT_GAP } from '@bedrock-rdk/constants';

/**
 * Setup use to give vertical’s rhythm to your services
 *
 * @version 2.5.0
 * @see https://zeroheight.com/726d5c282/v/0/p/719ab0-verticalspacing--v250
 */

export const PADDING = {
  // This padding will be applied if there is no title specified for a List
  TOP: {
    [HD]: 32,
    [FULL_HD]: 32,
  },
  BOTTOM: {
    [HD]: 16,
    [FULL_HD]: 32,
  },
  LEFT: {
    [HD]: 40,
    [FULL_HD]: 40,
  },
  RIGHT: {
    [HD]: safetyMargins.horizontal.HD,
    [FULL_HD]: safetyMargins.horizontal.FULL_HD,
  },
};

export const TITLE_PADDING = {
  TOP: {
    [HD]: 16,
    [FULL_HD]: 32,
  },
  BOTTOM: {
    [HD]: 12,
    [FULL_HD]: 24,
  },
};

export const FIRST_BLOCK_PADDING = {
  [HD]: 80,
  [FULL_HD]: 80,
};
